import React from 'react';
import './style/App.scss';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Home from './components/home';
import Signin from './components/signin';
import Signup from './components/signup';
import UserAfterLogin from './components/userafterlogin';
import NoMatch from './components/nomatch';
import AdminAfterLogin from './components/adminafterlogin';
import Booking from './components/makebooking';
import UpdateBook from './components/updatebooking';
import ManageBooking from './components/managebookings';
import MyBooking from './components/showallmybooking';
import UpdateProf from './components/updateprofile';
import Fleets from './components/allfleets';
import ManageUsers from './components/manageusers';
import Logout from './components/Logout'
import Help from './components/help'
import Team from './components/team'
import AdminRoute from './components/adminroutes'
import UserRoute from './components/userroutes'
import UserAdminRoute from './components/useradminroutes'

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/signup" component={Signup} />
          <Route path="/signin" component={Signin} />
          <UserRoute path="/userafterlogin" component={UserAfterLogin} />
          <AdminRoute path="/adminafterlogin" component={AdminAfterLogin} />
          <AdminRoute path="/displayall" component={ManageUsers} />
          <Route path="/allfleets" component={Fleets} />
          <AdminRoute path="/delete" component={ManageUsers} />
          <AdminRoute path="/search" component={ManageUsers} />
          <UserRoute path="/showallmybooking" component={MyBooking} />
          <AdminRoute path="/manageusers" component={ManageUsers} />
          <UserAdminRoute path="/updatebooking" component={UpdateBook} /> 
          <UserAdminRoute path="/updateprofile" component={UpdateProf} /> 
          <UserRoute path="/makebooking" component={Booking} />
          <AdminRoute path="/managebookings" component={ManageBooking} /> 
		      <Route path="/help" component={Help} />
          <Route path="/team" component={Team} />
          <Route path="/logout" component={Logout} />
          <Route component={NoMatch} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;




